// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5204ad6","453":"63c4db86","553":"f942302f"}[chunkId] + ".chunk.js";
};